import { useEffect, useState } from 'react'
import { mrbgStore } from './mrbgRedux/index.js'

function MrbgBilPayInfo({formID,formStyle}){

  const
    [bilID,setBilID] = useState( mrbgStore.getState().formsSettings[formID]?.STV.id ),
    [bilInfo,setBilInfo] = useState( null );

  useEffect( () => {
    console.log(formID,bilID)
    bilID?
      setBilInfo( mrbgStore.getState().mrbgVars.bilAmount[bilID] ):
      setBilInfo( null );

  }, [bilID] );
  useEffect(()=>{
    const unsubscribe = mrbgStore.subscribe(()=>{
      setBilID( mrbgStore.getState().formsSettings[formID]?.STV.id )
    })
    return () =>unsubscribe();
  })

  return(
    <ul className={formStyle.bilPayInfo} onClick={(e) => {
      navigator.clipboard.writeText(bilInfo?.bilAmount);
      e.target.classList.add(formStyle.copied);
      setTimeout(() => e.target.classList.remove(formStyle.copied), 1000);
    }}>
      <li>
        <span>مبلغ کل:</span>
        <span>مبلغ نهایی:</span>
        <span>مبلغ پرداخت شده:</span>
        <span>مبلغ صورت حساب کنونی:</span>
      </li>
      <li>
        <span data-content="Total Amount">{bilInfo?.totalAmount.toPrice() || ''}</span>
        <span data-content="Final Amount">{bilInfo?.finalAmount.toPrice() || ''}</span>
        <span data-content="payed Amount">{bilInfo?.totalAmountPaid.toPrice() || ''}</span>
        <span data-content="current amount" className={bilInfo?.bilAmount<0? formStyle.negativeDigit:''}>{bilInfo?.bilAmount.toPrice() || ''}</span>
      </li>
    </ul>
  )
}
export default MrbgBilPayInfo;